import { useEffect, useRef, useState } from "react";
import moment from "moment";
import { jsPDF } from "jspdf";
import CloseCash from "./CloseCash";
import { connect } from "react-redux";
import html2canvas from "html2canvas";
import { find, isEmpty } from "lodash";
import Alert from "../../../components/Alert";
import Table from "../../../components/Table";
import { TransactionTableHeader } from "../Constant";
import Receipt from "../../../assets/svgs/receipt.svg";
import { Actions } from "../../../internals/app/Actions";
import InvoiceDetail from "../../../components/InvoiceDetail";
import SendAsInvoiceDialog from "../../invoice/components/SendAsInvoiceDialog";
import { canSendAsInvoice } from "../../invoice/posModel";
import { canOpen } from "../../../internals/config/moduleAccess";
import TransactionHeader from "../../../components/TransactionHeader";
import { formatPrice } from "../../../internals/managers/PaymentManager";

// An invoice page with an arrow: "send as invoice", in the row icons' grey.
const SendInvoiceIcon = `data:image/svg+xml;utf8,${encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M2.5 0h6l4 4v4.2a.6.6 0 0 1-1.2 0V5H8.5a.5.5 0 0 1-.5-.5V1.2H2.5a.3.3 0 0 0-.3.3v13a.3.3 0 0 0 .3.3h5a.6.6 0 0 1 0 1.2h-5A1.5 1.5 0 0 1 1 14.5v-13A1.5 1.5 0 0 1 2.5 0ZM4 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Zm0 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3A.5.5 0 0 1 4 10Zm7.65.15a.5.5 0 0 1 .7 0l2.5 2.5a.5.5 0 0 1 0 .7l-2.5 2.5a.5.5 0 0 1-.7-.7l1.64-1.65H9.5a.5.5 0 0 1 0-1h3.79l-1.64-1.65a.5.5 0 0 1 0-.7Z" fill="#a5a6c3"/></svg>'
)}`;

const TransactionView = (props: any) => {
  const {
    alertStatus,
    openAlertBox,
    selectedShop,
    transactions,
    selectedScreen,
    setSelectedScreen,
    fetchOrderTransactions,
  } = props;
  const innerRef = useRef<any>();
  const [openReceipt, setOpenReceipt] = useState<boolean>(false);
  const [selectedTransaction, setSelectedTransaction] = useState<any>({});
  const [sendingOrder, setSendingOrder] = useState<any>(null);
  // Invoicing is a cloud_pos module; shops without it keep the receipt action only.
  const invoicing = canOpen("/invoices", props.shopModules);
  const [transactionTableData, setTransactionTableData] = useState<Array<any>>(
    []
  );

  useEffect(() => {
    if (transactions.transactions) {
      const tableData = getTransactionData(transactions.transactions);
      setTransactionTableData(tableData);
    }
  }, [transactions]);

  const normalizePaymentLabel = (method: string): string => {
    const m = (method || '').toLowerCase().replace(/[_\s-]/g, '');
    if (m === 'card' || m === 'creditcard' || m === 'credit') return 'Card';
    if (m === 'split') return 'Split';
    return 'Cash';
  };

  const getTransactionData = (data: any) => {
    return data.map((item: any) => {
      return {
        id: item.orderId,
        DATE: item.updatedTime,
        AMOUNT: item.totalPrice,
        ACTIONS: invoicing && canSendAsInvoice(item) ? [Receipt, SendInvoiceIcon] : [Receipt],
        "ORDER ID": item.orderId,
        EMPLOYEE: item.employeeName,
        "RECEIPT ID": item.recieptId,
        PAYMENT: normalizePaymentLabel(item.paymentMethod ?? item.payment ?? ''),
      };
    });
  };

  const onChangeExport = (option: any) => {
    if (option.value === "PDF") {
      const doc = new jsPDF("p", "mm");
      const data: any = document.getElementById("tableToPrint");
      html2canvas(data).then((canvas: any) => {
        const imgWidth = 210;
        const pageHeight = 295;

        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = 0;
        heightLeft -= pageHeight;
        doc.addImage(
          canvas,
          "PNG",
          0,
          position,
          imgWidth,
          imgHeight,
          "",
          "FAST"
        );
        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          doc.addPage();
          doc.addImage(
            canvas,
            "PNG",
            0,
            position,
            imgWidth,
            imgHeight,
            "",
            "FAST"
          );
          heightLeft -= pageHeight;
        }
        let title = moment().format("yyyy-MM-DD");
        doc.save(`invoices-${title}.pdf`);
      });
    } else {
      const header = ["Order Id", "Date", "Employee", "Receipt Id", "Amount"];
      const data = transactions?.transactions?.map((item: any) => {
        const time = moment(item.time, "hh:mm A").format("hh:mmA");
        const date = moment(item.date).format("DD/MM/YYYY");
        const price = formatPrice(item.totalPrice, selectedShop.currency);
        return [
          item.orderId,
          `${date} ${time}`,
          item.employeeName,
          item.recieptId,
          item.totalPrice,
        ];
      });
      const csvData: any = [header, ...data];
      let csvContent =
        "data:text/csv;charset=utf-8" +
        csvData.map((data: any) => data.join(",")).join("\n");

      var link = window.document.createElement("a");
      link.setAttribute("href", encodeURI(csvContent));
      let title = moment().format("yyyy-MM-DD");
      link.setAttribute("download", `invoices-${title}.csv`);
      link.click();
      // var encodedUri = encodeURI(csvContent);
      // window.open(encodedUri, `invoices-${title}.csv`);
    }
  };

  const toggleReceipt = () => {
    setOpenReceipt(!openReceipt);
  };

  const onClickInvoiceAction = (data: any, index: number) => {
    const transaction = find(
      transactions.transactions,
      (item) => item.orderId === data.id
    );
    setSelectedTransaction(transaction);
    if (index === 0) {
      toggleReceipt();
    } else if (index === 1) {
      setSendingOrder(transaction);
    }
  };

  const onScroll = () => {
    if (innerRef && innerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = innerRef.current;
      if (
        scrollTop + clientHeight >= scrollHeight &&
        transactions.nextLastKey
      ) {
        fetchOrderTransactions(
          selectedShop.shopId,
          30,
          transactions.nextLastKey
        );
      }
    }
  };

  const renderScreen = () => {
    switch (selectedScreen) {
      case "INVOICES":
        return (
          <>
            <TransactionHeader onChangeExport={onChangeExport} />
            <div
              ref={innerRef}
              onScroll={() => onScroll()}
              className={"overflow-auto relative"}
            >
              <Table
                {...{
                  tableHeader: TransactionTableHeader,
                  tableData: transactionTableData,
                  actionLabels: ["Receipt", "Send as invoice"],
                }}
                onClickItem={(data: any, index: number) =>
                  onClickInvoiceAction(data, index)
                }
              />
            </div>
          </>
        );
      case "CLOSE_CASH":
        return <CloseCash />;
    }
  };

  return (
    <div className="flex flex-col w-full p-6 justify-start h-full">
      <div className="bg-white rounded-xl border border-lavender shadow-sm p-6 flex flex-col flex-1 min-h-0">
      <Alert
        alertStatus={alertStatus}
        onCloseAlert={(status: any) =>
          openAlertBox(status, false, alertStatus.successStatus)
        }
      />
      <div className="flex flex-row gap-1 mb-6 border-b border-lavender">
        <button
          type="button"
          onClick={() => setSelectedScreen("INVOICES")}
          className={`pb-3 px-4 text-sm font-semibold border-b-2 -mb-px transition-colors ${
            selectedScreen === "INVOICES"
              ? "text-medium-slate-blue border-medium-slate-blue"
              : "text-echo-blue border-transparent hover:text-valhalla hover:border-echo-blue"
          }`}
          title="This tab was called Invoices. Invoices you send to customers are now under Invoices in the sidebar."
        >
          Receipts
          <span className="ml-1.5 text-[11px] font-medium text-text3">was Invoices</span>
        </button>
        <button
          type="button"
          onClick={() => setSelectedScreen("CLOSE_CASH")}
          className={`pb-3 px-4 text-sm font-semibold border-b-2 -mb-px transition-colors ${
            selectedScreen === "CLOSE_CASH" || selectedScreen === "DETAILS"
              ? "text-medium-slate-blue border-medium-slate-blue"
              : "text-echo-blue border-transparent hover:text-valhalla hover:border-echo-blue"
          }`}
        >
          Close Cash
        </button>
      </div>
      {renderScreen()}
      {!isEmpty(selectedTransaction) && (
        <InvoiceDetail
          isOpen={openReceipt}
          transaction={selectedTransaction}
          closeModal={() => toggleReceipt()}
          onSendAsInvoice={
            invoicing && canSendAsInvoice(selectedTransaction)
              ? () => {
                  toggleReceipt();
                  setSendingOrder(selectedTransaction);
                }
              : undefined
          }
        />
      )}
      {sendingOrder && (
        <SendAsInvoiceDialog
          shopId={selectedShop.shopId}
          order={sendingOrder}
          currency={selectedShop.currency || "LKR"}
          onClose={() => setSendingOrder(null)}
        />
      )}
      </div>
    </div>
  );
};
export default connect(
  (state: any) => ({
    alertStatus: state.common.get("alertStatus"),
    currentUser: state.setting.get("currentUser"),
    loadingAction: state.common.get("loadingAction"),
    selectedShop: state.dashboard.get("selectedShop"),
    transactions: state.transaction.get("transactions"),
    selectedScreen: state.transaction.get("selectedScreen"),
    shopModules: state.setting.get("shopModules"),
  }),
  {
    openAlertBox: Actions.common.openAlertBox,
    setSelectedScreen: Actions.transaction.setSelectedScreen,
    fetchOrderTransactions: Actions.transaction.fetchOrderTransactions,
  }
)(TransactionView);
